<template>
    <transition name="modal">
        <div class="dialog-modal-mask">
            <div class="small-panel" @click.stop>
                <div v-if="isLinkTypeToken()" class="dialog-title" v-t="'message.title_edit_key_vault'"></div>
                <div v-else class="dialog-title" v-t="'message.title_edit_key_vault2'"></div>
                <hr class="dialog-hr">
                <div class="dialog-body-small">
                    <el-form label-width="150px" >
                        <div class="dialog-form-item">
                            <el-form-item prep="displayName" ref="displayName">
                                <div slot="label" style="text-align:left"><span v-t="'message.item_display_name'"></span> <span class="required" v-t="'message.item_required'"></span></div>
                                <el-input id="displayName" size="large" type="text" :placeholder="$t('message.place_holder_input_text')" v-model="inputForm.displayName.value"
                                     @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                     clearable @clear="InputCheckAll()"/>
                            </el-form-item>
                            <el-form-item v-if="!isLinkTypeToken()" prep="token" ref="token">
                                <div slot="label" style="text-align:left"><span v-t="'message.item_token'"></span><span class="required" v-t="'message.item_required'"></span></div>
                                <el-input id="token" size="large" type="textarea" :autosize="{ minRows: 7, maxRows: 7}" :placeholder="tokenPlaceholder" v-model="inputForm.token.value"
                                     @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                     clearable @clear="InputCheckAll()"/>
                            </el-form-item>
                        </div>
                    </el-form>
                </div>
                <hr class="dialog-hr">
                <div class="dialog-button-field">
                    <el-button class="dialog-cancel-button" @click="$emit('cancel')" v-t="'message.button_cancel'"></el-button>
                    <el-button class="dialog-ok-button" :disabled="this.$data.disableButton" @click="saveChange()" v-t="'message.button_save'"></el-button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import charactercheck from './charactercheck.js';
import commonValidate from './common-validate.js';
import constants from './constants.js';
import commonUtil from './commonutil.js';

export default {
    data() {
        return {
            inputForm: {
                displayName: { validationRule: "reqDisplayName",       valid: false,    value: null,   isComposing: false },
                token:       { validationRule: "reqToken",             valid: false,    value: null,   isComposing: false },
            },
            disableButton: false,
            tokenPlaceholder: '',
        };
    },
    methods: {
        inputCheck(eventTargetId) {
            if (this.inputForm[eventTargetId].isComposing) {
                // inputting with IME
                return;
            }
            let validateResult = commonValidate.validateItem(this.$i18n, this.inputForm[eventTargetId].validationRule, this.inputForm[eventTargetId].value);
            if (validateResult.valid) {
                this.$refs[eventTargetId].clearValidate();
                this.disableButton = false;
            } else {
                this.$refs[eventTargetId].validateState = "error";
                this.$refs[eventTargetId].validateMessage = validateResult.message;
                this.disableButton = true;
            }
        },
        InputCheckAll() {
            for (let targetId in this.inputForm) {
                this.inputCheck(targetId);
            }
        },
        setButtonStatus() {
            if (commonValidate.checkFormValidation(this.inputForm)) {
                this.disableButton = false;
            } else {
                this.disableButton = true;
            }
        },
        compositionStart(eventTargetId) {
            this.inputForm[eventTargetId].isComposing = true;
        },
        compositionEnd(eventTargetId) {
            this.inputForm[eventTargetId].isComposing = false;
            this.inputCheck(eventTargetId)
        },
        isLinkTypeToken() {
            if (this.keyVault.serviceId == constants.VAULT_SERVICE_STORAGE) {
                return true;
            } else {
                return false;
            }
        },
        saveChange() {
            if (this.keyVault.serviceId == constants.VAULT_SERVICE_STORAGE) {
                this.$emit('save', {newName: this.$data.inputForm.displayName.value })
            } else {
                this.$emit('save', {
                    newName: this.$data.inputForm.displayName.value,
                    newToken: this.$data.inputForm.token.value
                });
            }
        },
    },
    created: function() {
        this.inputForm.displayName.value = this.keyVault.displayName;
        if (this.keyVault.serviceId == constants.VAULT_SERVICE_STORAGE) {
            this.inputForm.displayName.validationRule = "none";
            this.inputForm.displayName.valid = true;
        } else {
            this.tokenPlaceholder = commonUtil.getMessageText(this.$i18n, 'place_holder_current_value').replace('{currentValue}', this.keyVault.token);
        }
        this.disableButton = true;
    },
    props: [ 'keyVault' , 'sharedKey' ]
}
</script scoped>

